export async function useTranslatedSlugs(translationOfNid: number) {
  if (import.meta.client) {
    return
  }

  const { data: slugs } = await useAsyncData(() =>
    createNodesRepository().getTranslatedSlugs(translationOfNid)
  )

  const setI18nParams = useSetI18nParams()
  setI18nParams({
    en: { slug: slugs.value?.en },
    de: { slug: slugs.value?.de },
    fr: { slug: slugs.value?.fr },
    cs: { slug: slugs.value?.cs },
  })

  const head = useLocaleHead()

  useHead({
    htmlAttrs: head.value.htmlAttrs,
    link: head.value.link,
    meta: head.value.meta,
  })
}
